export default __webpack_public_path__ + "static/univers-rounded-black-fbace661d83385f46f86a6da77ec01ac.woff";